module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-01.54a2ae67.png";